// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDj_AubL4D1UZ0m5hgSVgGBRJSOFMKSb28",
  authDomain: "emme-managment.firebaseapp.com",
  databaseURL: "https://emme-managment.firebaseio.com",
  projectId: "emme-managment",
  storageBucket: "emme-managment.appspot.com",
  messagingSenderId: "986275848366",
  appId: "1:986275848366:web:6793f42ebbe3bfa7c54d3f",
  measurementId: "G-GK1J8XBWJ8",
};

let firebaseApp = false;
let app = null;
let analytics = null;

const initialize = () => {
  try {
    // Check if running in Instagram browser
    const str = navigator.userAgent;
    const i = str.indexOf("Instagram");
    if (i !== -1) {
      console.warn("Firebase initialization skipped: Running in Instagram browser");
      return false;
    }

    // Initialize Firebase
    app = initializeApp(firebaseConfig);

    // Initialize analytics if possible
    try {
      analytics = getAnalytics(app);
    } catch (error) {
      console.warn("Analytics initialization failed:", error);
    }

    firebaseApp = true;
    return true;
  } catch (error) {
    console.error("Firebase initialization failed:", error);
    return false;
  }
};

export async function logAnalyticsEvent(event, content) {
  try {
    if (!firebaseApp && initialize()) {
      if (!analytics) {
        console.warn("Analytics service not initialized");
        return;
      }
      logEvent(analytics, event, content);
    }
  } catch (error) {
    console.error("Error logging analytics event:", error);
  }
}
